import { getSanityImgUrl } from "@lib/sanity";
import Link from "next/link";
import { PrimaryButton, styled } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import { SanityProductCardInstance } from "@sourceful/shared-types";
import { GenericProductCard } from ".";

export const ImagePanel = styled("div", {
  img: {
    width: "100%",
  },
});

export interface ProductCardProps {
  className?: string;
  card: SanityProductCardInstance;
}

const ProductCard: React.FC<ProductCardProps> = ({ card, className }) => {
  const {
    image,
    title,
    subtitle,
    ctaText,
    customCTA,
    useDefaultProductImage,
    useProductNameAsTitle,
    product,
  } = card.productCard;

  const getImageUrl = () => {
    if (useDefaultProductImage && product && product.images) {
      return product?.images[0]?.asset?._ref || image?.asset?._ref || "";
    }

    if (image?.asset?._ref) {
      return image?.asset?._ref || "";
    }

    if (product?.images) {
      return product?.images[0]?.asset?._ref || "";
    }

    return "";
  };

  const imageUrl = getSanityImgUrl(getImageUrl(), base => base.height(600).width(600));

  return (
    <GenericProductCard
      className={className}
      imageUrl={imageUrl}
      title={useProductNameAsTitle ? product?.name || title : title}
      subtitle={subtitle}
      renderCTA={() => (
        <Link passHref href={customCTA ? customCTA.url : `/buy/${product?.slug}`} legacyBehavior>
          <PrimaryButton
            as="a"
            css={{
              width: "100%",
              marginTop: toRem(16),
            }}
          >
            {customCTA ? customCTA.title : ctaText}
          </PrimaryButton>
        </Link>
      )}
    />
  );
};

export default ProductCard;
